import { useEffect } from 'react';

const useTabChange = (onChange, url, title, tooltip, isDirty) => {
  useEffect(() => {
    if (onChange) {
      onChange({
        url, title, tooltip, isDirty,
      });
    }
  }, [url, title, tooltip, isDirty]);
};

export default {
  useTabChange,
};
